// https://vuex.vuejs.org/en/mutations.html
export default {
  family_attribute(state, payload) {
    state.family_attribute = payload;
  },
};
